import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from 'react-bootstrap';

export const LoanLeaseModal = ({ ...options }) => {
	const { showState, closeMethod, title, body, isMobile } = options;
	return (
		<Modal
			show={showState}
			onHide={() => closeMethod()}
			className={`m-1 ${isMobile ? 'dock-right' : null}`}
			animation={!isMobile}
		>
			<div className="m-1">
				<Modal.Header>
					<Modal.Title className="text-center">
						<button
							type="button"
							aria-label="Close"
							className="close text-muted"
							onClick={() => closeMethod()}
						>
							<i
								className="ddc-icon ddc-icon-close"
								aria-hidden="true"
							/>
						</button>
						<h3 className="my-0 px-5">{title}</h3>
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>{body}</Modal.Body>
			</div>
		</Modal>
	);
};

LoanLeaseModal.propTypes = {
	showState: PropTypes.bool.isRequired,
	closeMethod: PropTypes.func.isRequired,
	title: PropTypes.element.isRequired,
	body: PropTypes.element.isRequired
};

export default LoanLeaseModal;



// WEBPACK FOOTER //
// ./src/components/LoanLeaseModal.jsx